import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import GlobalTable from '../components/GlobalTable';
import { useLazyTable } from '../hooks/useLazyTable';
import axiosInstance from '../services/axiosInstance';
import { handleApiError } from '../components/apiErrorHandler';
import { useBreadcrumbs } from "../contexts/BreadcrumbContext";

const SupplierInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { lazyParams, onPage, onSort, onFilter, queryParams } = useLazyTable({ rows: 15 });
  const [loading, setLoading] = useState(false);
  const { push, beginDrilldown } = useBreadcrumbs();
  const navigate = useNavigate();

  const loadInvoices = () => {
    setLoading(true);
    axiosInstance
      .get('/api/supplier-invoices/', { params: queryParams })
      .then((res) => {
        setInvoices(res.data.results || []);
        setTotalRecords(res.data.count || 0);
      })
      .catch(handleApiError)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadInvoices();
  }, [queryParams]);

  const statusBodyTemplate = (row) => {
    let sev = 'info';
    switch (row.status) {
      case 'open':
        sev = 'warning';
        break;
      case 'paid':
        sev = 'success';
        break;
      case 'overdue':
        sev = 'danger';
        break;
      case 'cancelled':
        sev = 'danger';
        break;
      default:
        sev = 'info';
    }
    const label = (row.status || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    return <Tag value={label || '-'} severity={sev} />;
  };

  const columns = [
    {
      Header: 'Invoice #',
      accessor: 'invoice_number',
      filtered: true,
    },
    {
      Header: 'Supplier',
      accessor: 'supplier_name',
      filtered: true,
    },
    {
      Header: 'Move Order',
      accessor: 'mo_number',
      filtered: true,
      bodyTemplate: (row) => (
            <span
                style={{ color: '#2563eb', cursor: 'pointer' }}
                onClick={() =>{
                    beginDrilldown();
                    navigate('/moveorders', {
                        state: {moId: row.move_order}
                    });
                    push({
                        label: `Supplier Invoices`,
                        path: '/supplier-invoices',
                    });
                    push({
                        label: `Move Orders`,
                        path: '/moveorders',
                    });
                    push({
                        label: `Order: ${row.mo_number}`,
                        path: `/moveorders`,
                        state: {moId: row.move_order}
                    });
                }}
            >
                {row.mo_number}
            </span>
            )
    },
    {
      Header: 'Total Amount',
      accessor: 'total_amount',
      dataType: 'currency',
    },
    {
      Header: 'Outstanding',
      accessor: 'outstanding_amount',
      dataType: 'currency',
    },
    {
      Header: 'Due Date',
      accessor: 'due_date',
      dataType: 'date',
      sortable: true,
    },
    {
      Header: 'Status',
      accessor: 'status',
      filtered: true,
      bodyTemplate: statusBodyTemplate,
    },
  ];

  const headerAction = (
    <Button
      type="button"
      icon="pi pi-refresh"
      label="Refresh"
      outlined
      onClick={loadInvoices}
      className="w-full sm:w-auto"
    />
  );

  return (
    <div className="containers">
      <GlobalTable
        columns={columns}
        data={invoices}
        loading={loading}
        tabletitle="Supplier Invoices"
        showEditColumn={false}
        lazy
        totalRecords={totalRecords}
        lazyParams={lazyParams}
        onPage={onPage}
        onSort={onSort}
        onFilter={onFilter}
        headerAction={headerAction}
      />
    </div>
  );
};

export default SupplierInvoices;